var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.deviceFeatures.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "row", attrs: { id: "anchor-technical-sheet" } }, [
      _vm.packContent
        ? _c("div", { staticClass: "mb-2" }, [
            _c("p", { staticClass: "lead mb-0" }, [
              _c("strong", [_vm._v(_vm._s(_vm.packContent.title))]),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "mb-0",
              domProps: { innerHTML: _vm._s(_vm.packContent.text) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-unstyled" },
        _vm._l(_vm.deviceFeatures.technicalFeatures, function (feature, index) {
          return _c("li", { key: index, staticClass: "list-item" }, [
            _c("div", {
              directives: [
                {
                  name: "msh-html",
                  rawName: "v-msh-html",
                  value: feature.title,
                  expression: "feature.title",
                },
              ],
              staticClass: "list-item-title",
            }),
            _vm._v(" "),
            _c("div", { staticClass: "list-item-text" }, [
              feature.link
                ? _c(
                    "a",
                    {
                      staticClass: "text-break",
                      attrs: { href: feature.text, target: "_blank" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(feature.text) +
                          "\n                    "
                      ),
                    ]
                  )
                : _c("span", {
                    directives: [
                      {
                        name: "msh-html",
                        rawName: "v-msh-html",
                        value: feature.text,
                        expression: "feature.text",
                      },
                    ],
                  }),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }